module.exports = __webpack_public_path__ + "static/media/1.95410f87.svg";